export default __webpack_public_path__ + "static/media/transported.4d97ca00.svg";